import type { TagRenderSize } from '../../TagRender';

export const SIZES: Record<TagRenderSize, string> = {
  S: 'Small - best for social media posts',
  M: 'Medium - best for quotes',
  L: 'Large - best for printed adverts',
  XL: 'Extra Large - best for van stickers',
};
